import { Link } from "react-router-dom";
import BrandMark from "@/components/BrandMark";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 bg-black px-6 md:px-12 lg:px-24 py-12">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        <div>
          <div className="flex items-center gap-3 mb-3">
            <BrandMark size={64} />
            <div>
              <div className="font-display text-xl font-medium leading-none">
                BeatCred<span className="text-amber-500">si</span><span className="text-amber-500 text-xs align-super">™</span>
              </div>
              <div className="font-mono-tech text-xs text-amber-500 uppercase tracking-widest mt-1">
                Infrastructure Over Hype.™
              </div>
            </div>
          </div>
          <p className="text-xs text-neutral-500 leading-relaxed">
            The Music Infrastructure Intelligence Platform.<br />
            Built by <span className="text-neutral-300">Smartian Tech<span className="text-amber-500">™</span></span><br />
            © 2026 Only Few Get Selected, LLC. All Rights Reserved.
          </p>
        </div>

        <div>
          <div className="text-overline mb-4">Platform</div>
          <ul className="space-y-2 text-sm text-neutral-400">
            <li><Link to="/" className="hover:text-amber-500" data-testid="footer-home">Home</Link></li>
            <li><Link to="/login" className="hover:text-amber-500" data-testid="footer-login">Log In</Link></li>
            <li><Link to="/signup" className="hover:text-amber-500" data-testid="footer-signup">Sign Up</Link></li>
            <li><Link to="/dashboard" className="hover:text-amber-500" data-testid="footer-dashboard">Dashboard</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-overline mb-4">Legal &amp; Contact</div>
          <ul className="space-y-2 text-sm text-neutral-400">
            <li><Link to="/terms" className="hover:text-amber-500" data-testid="footer-terms">Terms of Service</Link></li>
            <li><Link to="/privacy" className="hover:text-amber-500" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link to="/refunds" className="hover:text-amber-500" data-testid="footer-refunds">Refund Policy</Link></li>
            <li><Link to="/cookies" className="hover:text-amber-500" data-testid="footer-cookies">Cookie Policy</Link></li>
            <li><Link to="/aup" className="hover:text-amber-500" data-testid="footer-aup">Acceptable Use Policy</Link></li>
            <li>
              <a href="mailto:contact@onlymartian.com" className="hover:text-amber-500" data-testid="footer-contact">
                contact@onlymartian.com
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto pt-8 mt-8 border-t border-white/5">
        <div className="bg-amber-500/5 border border-amber-500/20 px-5 py-4 mb-4" data-testid="ownership-notice">
          <div className="text-overline text-amber-500 mb-2">Ownership Notice</div>
          <p className="text-xs text-neutral-300 leading-relaxed">
            <strong className="text-white">BeatCredsi<span className="text-amber-400">™</span> is a proprietary platform owned and operated by Only Few Get Selected, LLC through Smartian Tech<span className="text-amber-400">™</span>.</strong>{" "}
            All source code, scoring algorithms, trademarks, and intellectual property are the exclusive property of Only Few Get Selected, LLC. © 2026. All Rights Reserved. For inquiries, contact{" "}
            <a href="mailto:contact@onlymartian.com" className="text-amber-400 hover:text-amber-300 underline underline-offset-2">contact@onlymartian.com</a>.
          </p>
        </div>
        <div className="text-xs font-mono-tech text-neutral-600 uppercase tracking-widest">
          Built by Smartian Tech™ · Infrastructure Over Hype™
        </div>
      </div>
    </footer>
  );
}
